<template>
    <v-app>
        <b-announcement
            v-if="store&&store.active_subscription === false"
            color="error"
            text-color="black"
        >
            {{ translations.subscriptionInactiveErrorPart1[lang] }}
            <router-link
                :to="`/${lang}/${panelType}/general-settings/billing-dashboard`"
                class="b-signin-link"
                ><span style="color:black; text-decoration: underline;">{{
                    translations.subscriptionInactiveErrorPart2[lang]
                }}</span></router-link
            >
            {{ translations.subscriptionInactiveErrorPart3[lang] }}
        </b-announcement>
        <b-announcement
            v-if="store&&store.cancelled_subscription === true"
            color="warning"
            text-color="black"
        >
            {{ translations.subscriptionCancelledErrorPart1[lang] }}
            {{ getDateString(store.expiration_date_subscription)  }}
        </b-announcement>
        <router-view name="header"></router-view>

        <v-main :class="{ 'pa-0': noPadding }">
            <router-view></router-view>
            <Notification />
            <PermissionDialog />
            
        </v-main>
        <router-view name="footer"></router-view>
    </v-app>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import Notification from "@/components/general/Notification.vue";
import PermissionDialog from "@/components/general/PermissionDialog.vue";
import translations from "@/utils/translations/global";
import API from "@/models/API";

export default {
    name: "App",

    components: { Notification, PermissionDialog },
    mixins: [translations],

    data: () => ({
        //
    }),

    computed: {
        ...mapState(["store", "panelType"]),

        lang() {
            return this.$route.params.lang;
        },

        noPadding() {
            return (
                this.$route.path === `/` ||
                this.$route.path === `/${this.lang}/` ||
                this.$route.path === `/${this.lang}` ||
                this.$route.path === `/${this.lang}/points-pos` ||
                this.$route.path === `/${this.lang}/points-pos/`
            );
        },
    },

    methods: {
        ...mapMutations(["setStoreId", "setAccessToken", "setNotification"]),
        ...mapActions(["getUser", "loadAppProvider"]),
        getDateString(val) {
            if (!val) return '-';
            let date = new Date(val);
            return date.toLocaleDateString(this.lang)
        }
    },
    
    watch:{
        lang(val) {
            API.defaults.headers['X-Locale'] = val;
        },
        errorMessage: {
            handler(val) {
                if (val) {
                    this.setNotification({
                        show: true,
                        type: "error",
                        text: val
                    });
                }
            }
        },
    },

    // async beforeCreate() {
    //     if (Object.keys(caches).length) {
    //         const names = await caches.keys();
    //         await Promise.all(names.map((name) => caches.delete(name)));
    //         window.location.reload();
    //     }
    // },

    mounted() {
        const accessToken = localStorage.getItem("accessToken");
        const storeId = localStorage.getItem("storeId");

        if (accessToken) {
            this.setAccessToken(accessToken);
        }

        if (storeId) {
            this.setStoreId(storeId);
            this.loadAppProvider();
        }
    },
};
</script>

<style>
.bb {
    border: 1px solid black !important;
}

.bw {
    border: 1px solid white !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

html,
body {
    scroll-behavior: smooth !important;
}

.vuejs-clipper-basic__zoom-area {
    border-radius: 50%;
}
</style>
